import type { RegisterItemList } from "@services/registers/list/type";
import { formatDateTime } from "@utils/formatters";
import {
  getEnvironmentLabel,
  getTypeLabel,
  REGISTER_TYPE_COLORS,
  type RegisterType,
} from "@typings/entities/registers/enums";
import type { Register } from "@typings/entities/registers";
import type { RegistersGeoJsonResponse } from "@services/registers/getGeoJson/type";

export interface RegisterItemListWithLabels
  extends Omit<RegisterItemList, "environment" | "type"> {
  environment: string;
  type: string;
}

export interface RegisterWithLabels
  extends Omit<Register, "environment" | "type"> {
  environment: string;
  type: string;
}

export function prepareRegistersTable(
  registers: RegisterItemList[],
): RegisterItemListWithLabels[] {
  return registers.map((register) => ({
    ...register,
    registerDate: formatDateTime(register.registerDate || null),
    environment: register.environment
      ? getEnvironmentLabel(register.environment)
      : "",
    type: getTypeLabel(register.type),
  }));
}

export function prepareRegistersView(register: Register): RegisterWithLabels {
  return {
    ...register,
    registerDate: formatDateTime(register.registerDate || null),
    environment: register.environment
      ? getEnvironmentLabel(register.environment)
      : "",
    type: getTypeLabel(register.type),
  };
}

export function mapColorInRegisters(
  geoJson: RegistersGeoJsonResponse,
): RegistersGeoJsonResponse {
  return {
    ...geoJson,
    features: geoJson.features.map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        color:
          REGISTER_TYPE_COLORS[feature.properties.type as RegisterType].hex,
      },
    })),
  };
}
